export default function shallowEqual(a, b) {
    for (const key in a) {
        if (!a.hasOwnProperty(key)) continue;

        if (!b.hasOwnProperty(key)) {
            return false;
        }
        if (a[key] != b[key]) {
            return false;
        }
    }

    for (const key in b) {
        if (!b.hasOwnProperty(key)) continue;

        if (!a.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
}

function jsonEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
}

const jsonWarned = Symbol('jsonEqual');
export function shouldComponentUpdate(
    { state, props, constructor },
    nextProps,
    nextState
) {
    if (shallowEqual(state, nextState) && shallowEqual(props, nextProps)) {
        return false;
    }

    if (process.env.NODE_ENV == 'production') {
        return true;
    }

    // Hopefully a temporary hack until we can get selectors to always return
    // shallow-equal states.
    try {
        /* eslint-disable no-console */
        if (jsonEqual(state, nextState) && jsonEqual(props, nextProps)) {
            if (
                process.env.NODE_ENV != 'production' &&
                !constructor[jsonWarned]
            ) {
                constructor[jsonWarned] = true;
                console.warn(
                    `shouldComponentUpdate had to fall back to JSON.stingify for ${constructor.displayName}`
                ); // eslint-disable-line no-console
                Object.keys(state).forEach(key => {
                    if (state[key] != nextState[key]) {
                        console.log('state: ', key);
                    }
                });
                Object.keys(props).forEach(key => {
                    if (props[key] != nextProps[key]) {
                        console.log('props: ', key);
                    }
                });

                // Render even though we know nothing has changed.
                return true;
            }
        }
        /* eslint-enable no-console */
    } catch (e) {
        /* skip JSON errors */
    }

    return true;
}



// WEBPACK FOOTER //
// ./src/shallow_equal.js